// LoginRequiredPage.jsx
import React, { useEffect, useState } from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { useAuth } from '../auth/AuthContext';
import './LoginRequiredPage.css'; // 我們稍後會創建這個CSS檔案

const LoginRequiredPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loading, login } = useAuth();
  const [showAnnouncement, setShowAnnouncement] = useState(false);

  // 設置頁面標題
  useEffect(() => {
    document.title = '需要登入';
  }, []);

  // 如果用戶已經登入，則重定向到首頁
  useEffect(() => {
    if (!loading && isAuthenticated) {
      navigate('/');
    }
  }, [loading, isAuthenticated, navigate]);

  // 處理登入按鈕點擊 - 先顯示公告
  const handleLogin = () => {
    setShowAnnouncement(true);
  };

  // 用戶確認後才執行登入
  const handleConfirm = () => {
    setShowAnnouncement(false);
    login();
  };

  // 載入中顯示載入動畫
  if (loading) {
    return (
      <div className="container my-5 pt-5 text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">載入中...</span>
        </div>
        <p className="mt-3">載入中，請稍候...</p>
      </div>
    );
  }

  return (
    <>
      <Modal show={showAnnouncement} onHide={() => setShowAnnouncement(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>系統公告</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="warning" className="mb-3">
            <Alert.Heading>帳號系統已全面更換</Alert.Heading>
            <p>
              我們的帳號系統已完成全面升級，<strong>所有舊帳號資料已重置</strong>。
            </p>
            <p>
              請使用您原本的 Email 重新註冊並登入。
            </p>
            <hr />
            <p className="mb-0">
              如有任何問題，請聯絡管理員：<a href="mailto:admin@nogi46.me">admin@nogi46.me</a>
            </p>
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAnnouncement(false)}>
            取消
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            我已了解，繼續登入
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="login-required-container">
      <div className="login-required-content">
        <div className="login-required-header">
          <h2>需要登入</h2>
        </div>
        
        <div className="login-required-body">
          <Alert variant="info" className="mb-4">
            <Alert.Heading>您需要登入才能瀏覽此頁面</Alert.Heading>
            <p>
              您嘗試瀏覽的頁面需要用戶登入才能查看。請點擊下方按鈕登入系統，或返回首頁。
            </p>
            <hr />
            <p className="mb-0">
              如有疑問，請聯絡管理員：<a href="mailto:admin@nogi46.me">admin@nogi46.me</a>
            </p>
          </Alert>

          <div className="login-required-animation">
            <div className="animation-wrapper">
              <img 
                src="/images/gif/kaki.gif"
                alt="需要登入"
                className="login-required-image"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/avatar/乃木坂46.jpg";
                }}
              />
            </div>
            <p className="animation-caption">登入後即可瀏覽完整內容...</p>
          </div>

          <div className="login-required-actions">
            <Button 
              variant="primary" 
              size="lg" 
              onClick={handleLogin}
            >
              立即登入
            </Button>
            <Button 
              variant="outline-secondary" 
              size="lg" 
              onClick={() => navigate('/')}
            >
              返回首頁
            </Button>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default LoginRequiredPage;